export enum PremiumTipType {
	AUTOMATION = 'automation',
	GENERIC = 'generic',
}
